import React from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "../firebase/firebase";
import "./NotFoundPage.css";
import Navmenu from "../components/Navmenu";

const NotFoundPage: React.FC = () => {
  const [user, setUser] = React.useState<User | null>(auth.currentUser);

  React.useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  const name = user?.displayName || user?.email || "User";
  const role = "Admin";

  return (
    <div className="notFoundPage">
      <Navmenu />

      <main className="notFoundBody">
        <div className="notFoundCode">404</div>
        <h2>Page Not Found</h2>
        <p>
          Sorry, the page you are looking for does not exist or has been moved.
          Please go back to the application home.
        </p>
        <Link to="/agents" className="notFoundButton">
          Back to Agents
        </Link>
      </main>
    </div>
  );
};

export default NotFoundPage;
